import { z } from 'zod';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';

/**
 * Vendor performance record — delivery, acceptance, deviations and
 * checkpoint results, all counted in code from the contract records.
 *
 *   GET /api/v1/contract/engagements/:id/vendor-performance
 */
export const VendorPerformanceSchema = z.object({
  delivery: z.object({
    due: z.number(),
    on_time: z.number(),
    late: z.number(),
    missing: z.number(),
    on_time_rate: z.number().nullable(),
  }),
  acceptance: z.object({
    reviewed: z.number(),
    first_time_accepted: z.number(),
    first_time_rate: z.number().nullable(),
  }),
  deviations: z.object({
    open: z.object({ Critical: z.number(), High: z.number(), Medium: z.number(), Low: z.number() }),
    resolved: z.number(),
    waived: z.number(),
    response_deadline_missed: z.number(),
  }),
  checkpoints: z.object({
    total: z.number(),
    scored: z.number(),
    green: z.number(),
    divergent: z.number(),
    red: z.number(),
    unverified: z.number(),
  }),
});
export type VendorPerformance = z.infer<typeof VendorPerformanceSchema>;

export function useVendorPerformanceQuery(engagementId: string | undefined) {
  return useQuery({
    queryKey: ['vendor-performance', engagementId] as const,
    queryFn: () =>
      apiClient(
        `/api/v1/contract/engagements/${encodeURIComponent(engagementId!)}/vendor-performance`,
        VendorPerformanceSchema,
      ),
    enabled: Boolean(engagementId),
  });
}
